import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Device } from '@capacitor/device';
import { filter, switchMap, take } from 'rxjs/operators';

/**
 * Appende in un parametro http la piattaforma su cui l'app
 * è in esecuzione
 */
@Injectable({
  providedIn: 'root'
})
export class PlatformInterceptorService implements HttpInterceptor {

  private platformSubject = new BehaviorSubject<'web' | 'ios' | 'android' | 'electron'>(null);

  private platform$(): Observable<'web' | 'ios' | 'android' | 'electron'> {
    return this.platformSubject.asObservable().pipe(filter(value => !!value));
  }

  constructor() {
    Device.getInfo().then(deviceInfo => {
      const { platform } = deviceInfo;
      console.log(`Http request will specify the plaftorm '${platform}'`);
      this.platformSubject.next(platform);
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.platform$().pipe(
      take(1),
      switchMap(platform => {
        const requestWithPlatform = req.clone({
          params: req.params.append('platform', platform)
        });
        return next.handle(requestWithPlatform);
      }));
  }
}


